import { render, staticRenderFns } from "./SpamBannerEl.vue?vue&type=template&id=62baefee&"
import script from "./SpamBannerEl.vue?vue&type=script&lang=ts&"
export * from "./SpamBannerEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports